// Generated by scripts/build-ui-icons.mjs.
import { createAppIcon } from "./base";
import { SignpostIcon as SignpostGlyph } from "@phosphor-icons/react/dist/ssr/Signpost";
import { SlidersHorizontalIcon as SlidersHorizontalGlyph } from "@phosphor-icons/react/dist/ssr/SlidersHorizontal";
import { SmileyIcon as SmileyGlyph } from "@phosphor-icons/react/dist/ssr/Smiley";
import { SmileyWinkIcon as SmileyWinkGlyph } from "@phosphor-icons/react/dist/ssr/SmileyWink";
import { SortAscendingIcon as SortAscendingGlyph } from "@phosphor-icons/react/dist/ssr/SortAscending";
import { SortDescendingIcon as SortDescendingGlyph } from "@phosphor-icons/react/dist/ssr/SortDescending";
import { SparkleIcon as SparkleGlyph } from "@phosphor-icons/react/dist/ssr/Sparkle";
import { SpeakerHighIcon as SpeakerHighGlyph } from "@phosphor-icons/react/dist/ssr/SpeakerHigh";
import { SpeakerSlashIcon as SpeakerSlashGlyph } from "@phosphor-icons/react/dist/ssr/SpeakerSlash";
import { SquareIcon as SquareGlyph } from "@phosphor-icons/react/dist/ssr/Square";
import { SquaresFourIcon as SquaresFourGlyph } from "@phosphor-icons/react/dist/ssr/SquaresFour";
import { StackIcon as StackGlyph } from "@phosphor-icons/react/dist/ssr/Stack";
import { StarIcon as StarGlyph } from "@phosphor-icons/react/dist/ssr/Star";
import { StorefrontIcon as StorefrontGlyph } from "@phosphor-icons/react/dist/ssr/Storefront";
import { SunIcon as SunGlyph } from "@phosphor-icons/react/dist/ssr/Sun";
import { TagIcon as TagGlyph } from "@phosphor-icons/react/dist/ssr/Tag";
import { TargetIcon as TargetGlyph } from "@phosphor-icons/react/dist/ssr/Target";
import { TextAaIcon as TextAaGlyph } from "@phosphor-icons/react/dist/ssr/TextAa";
import { TextAlignLeftIcon as TextAlignLeftGlyph } from "@phosphor-icons/react/dist/ssr/TextAlignLeft";
import { TextTIcon as TextTGlyph } from "@phosphor-icons/react/dist/ssr/TextT";
import { TextboxIcon as TextboxGlyph } from "@phosphor-icons/react/dist/ssr/Textbox";
import { TimerIcon as TimerGlyph } from "@phosphor-icons/react/dist/ssr/Timer";
import { ToggleLeftIcon as ToggleLeftGlyph } from "@phosphor-icons/react/dist/ssr/ToggleLeft";
import { ToggleRightIcon as ToggleRightGlyph } from "@phosphor-icons/react/dist/ssr/ToggleRight";
import { ToiletIcon as ToiletGlyph } from "@phosphor-icons/react/dist/ssr/Toilet";
import { TranslateIcon as TranslateGlyph } from "@phosphor-icons/react/dist/ssr/Translate";
import { TrashIcon as TrashGlyph } from "@phosphor-icons/react/dist/ssr/Trash";
import { TrayIcon as TrayGlyph } from "@phosphor-icons/react/dist/ssr/Tray";
import { TreePalmIcon as TreePalmGlyph } from "@phosphor-icons/react/dist/ssr/TreePalm";
import { TrendDownIcon as TrendDownGlyph } from "@phosphor-icons/react/dist/ssr/TrendDown";
import { TrendUpIcon as TrendUpGlyph } from "@phosphor-icons/react/dist/ssr/TrendUp";
import { TrophyIcon as TrophyGlyph } from "@phosphor-icons/react/dist/ssr/Trophy";
import { UploadSimpleIcon as UploadSimpleGlyph } from "@phosphor-icons/react/dist/ssr/UploadSimple";
import { UserIcon as UserGlyph } from "@phosphor-icons/react/dist/ssr/User";
import { UserCheckIcon as UserCheckGlyph } from "@phosphor-icons/react/dist/ssr/UserCheck";

export const Signpost = /* @__PURE__ */ createAppIcon(
  SignpostGlyph,
  "Signpost",
);
export const SlidersHorizontal = /* @__PURE__ */ createAppIcon(
  SlidersHorizontalGlyph,
  "SlidersHorizontal",
);
export const Smiley = /* @__PURE__ */ createAppIcon(SmileyGlyph, "Smiley");
export const SmileyWink = /* @__PURE__ */ createAppIcon(
  SmileyWinkGlyph,
  "SmileyWink",
);
export const SortAscending = /* @__PURE__ */ createAppIcon(
  SortAscendingGlyph,
  "SortAscending",
);
export const SortDescending = /* @__PURE__ */ createAppIcon(
  SortDescendingGlyph,
  "SortDescending",
);
export const Sparkle = /* @__PURE__ */ createAppIcon(SparkleGlyph, "Sparkle");
export const SpeakerHigh = /* @__PURE__ */ createAppIcon(
  SpeakerHighGlyph,
  "SpeakerHigh",
);
export const SpeakerSlash = /* @__PURE__ */ createAppIcon(
  SpeakerSlashGlyph,
  "SpeakerSlash",
);
export const Square = /* @__PURE__ */ createAppIcon(SquareGlyph, "Square");
export const SquaresFour = /* @__PURE__ */ createAppIcon(
  SquaresFourGlyph,
  "SquaresFour",
);
export const Stack = /* @__PURE__ */ createAppIcon(StackGlyph, "Stack");
export const Star = /* @__PURE__ */ createAppIcon(StarGlyph, "Star");
export const Storefront = /* @__PURE__ */ createAppIcon(
  StorefrontGlyph,
  "Storefront",
);
export const Sun = /* @__PURE__ */ createAppIcon(SunGlyph, "Sun");
export const Tag = /* @__PURE__ */ createAppIcon(TagGlyph, "Tag");
export const Target = /* @__PURE__ */ createAppIcon(TargetGlyph, "Target");
export const TextAa = /* @__PURE__ */ createAppIcon(TextAaGlyph, "TextAa");
export const TextAlignLeft = /* @__PURE__ */ createAppIcon(
  TextAlignLeftGlyph,
  "TextAlignLeft",
);
export const TextT = /* @__PURE__ */ createAppIcon(TextTGlyph, "TextT");
export const Textbox = /* @__PURE__ */ createAppIcon(TextboxGlyph, "Textbox");
export const Timer = /* @__PURE__ */ createAppIcon(TimerGlyph, "Timer");
export const ToggleLeft = /* @__PURE__ */ createAppIcon(
  ToggleLeftGlyph,
  "ToggleLeft",
);
export const ToggleRight = /* @__PURE__ */ createAppIcon(
  ToggleRightGlyph,
  "ToggleRight",
);
export const Toilet = /* @__PURE__ */ createAppIcon(ToiletGlyph, "Toilet");
export const Translate = /* @__PURE__ */ createAppIcon(
  TranslateGlyph,
  "Translate",
);
export const Trash = /* @__PURE__ */ createAppIcon(TrashGlyph, "Trash");
export const Tray = /* @__PURE__ */ createAppIcon(TrayGlyph, "Tray");
export const TreePalm = /* @__PURE__ */ createAppIcon(
  TreePalmGlyph,
  "TreePalm",
);
export const TrendDown = /* @__PURE__ */ createAppIcon(
  TrendDownGlyph,
  "TrendDown",
);
export const TrendUp = /* @__PURE__ */ createAppIcon(TrendUpGlyph, "TrendUp");
export const Trophy = /* @__PURE__ */ createAppIcon(TrophyGlyph, "Trophy");
export const UploadSimple = /* @__PURE__ */ createAppIcon(
  UploadSimpleGlyph,
  "UploadSimple",
);
export const User = /* @__PURE__ */ createAppIcon(UserGlyph, "User");
export const UserCheck = /* @__PURE__ */ createAppIcon(
  UserCheckGlyph,
  "UserCheck",
);
